export default __webpack_public_path__ + "static/media/Himanshu-resume.bbf3b5f9.docx";